// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "activity-" + chunkId + ".js?v=" + "3385db40d47af8a16367" + "";
};